module.exports = __webpack_public_path__ + "img/fruit-mangoes-190x100.5c7cf8df.jpg";